import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import {
  DRAWER_PARAM_KEYS,
  getCleanDrawerParams,
  queryKeys,
  queryValues,
} from '@terminal/routes/query-params';

export const useThemeEarningsSummaryDrawer = () => {
  const { deleteQueryParam, params, setQueryParams } = useQueryParams();
  const isThemeEarningsDrawerOpen =
    params[queryKeys.activeDrawer] === queryValues.themeEarningsDrawer;
  const isNestedEarningsInsightDrawerOpen =
    params[queryKeys.activeDrawer] === queryValues.earningsInsightDrawer &&
    params[queryKeys.parentDrawer] === queryValues.themeEarningsDrawer;
  const isOpen = isThemeEarningsDrawerOpen || isNestedEarningsInsightDrawerOpen;
  const themeId = isOpen ? (params[queryKeys.themeId] ?? undefined) : undefined;

  const openDrawer = (selectedThemeId: string) => {
    setQueryParams({
      ...getCleanDrawerParams(),
      [queryKeys.drawerExpanded]: undefined,
      [queryKeys.activeDrawer]: queryValues.themeEarningsDrawer,
      [queryKeys.themeId]: selectedThemeId,
    });
  };

  const closeDrawer = () => {
    deleteQueryParam([...DRAWER_PARAM_KEYS, queryKeys.drawerExpanded]);
  };

  return {
    openDrawer,
    drawerProps: {
      isOpen: !!themeId,
      isNestedDrawerOpen: isNestedEarningsInsightDrawerOpen,
      onClose: closeDrawer,
      themeId,
    },
  };
};
